import {
  LuBriefcaseBusiness,
  LuCalendarDays,
  LuFolderOpen,
  LuIdCard,
  LuMessagesSquare,
  LuScrollText,
  LuTreePalm,
  LuTruck,
  LuWallet,
} from 'react-icons/lu';

/**
 * Sections of the profile page. Tab keys are the ones other screens open the
 * page with (`navigate('/profile', { state: { activeTab } })`), so they stay
 * as they were. A group with `tabs: null` is a single tab named like the group.
 */
export const TAB_GROUPS = [
  { key: 'takvim-ajanda', icon: LuCalendarDays, tabs: ['takvim', 'ajandam'] },
  { key: 'dosyalar', icon: LuFolderOpen, tabs: null },
  { key: 'projelerim', icon: LuBriefcaseBusiness, tabs: null },
  { key: 'izin-yonetimi', icon: LuTreePalm, tabs: ['izin-talep', 'izin-taleplerim'] },
  { key: 'masraf-yonetimi', icon: LuWallet, tabs: ['masraf-talep', 'masraf-takip', 'masraf-talepleri'] },
  { key: 'iletisim-bildirim', icon: LuMessagesSquare, tabs: ['mesajlar', 'bildirimler', 'sistem-hata-bildirimleri'] },
  { key: 'dilekce-yonetimi', icon: LuScrollText, tabs: ['sikayetlerim', 'gelen-sikayetler'] },
  { key: 'cv-yonetimi', icon: LuIdCard, tabs: ['cv-tr', 'cv-en', 'gcp', 'iata'] },
  { key: 'kargolarim', icon: LuTruck, tabs: null },
];

// The calendar is what most people come for, so the page opens on it
export const DEFAULT_TAB = 'takvim';

/** The group a tab belongs to (a single-tab group is its own tab). */
export const groupOfTab = (tab) => TAB_GROUPS.find((group) => group.key === tab || group.tabs?.includes(tab));

/** Tabs of a group, single-tab groups included. */
export const tabsOfGroup = (group) => group.tabs || [group.key];

/**
 * Who sees what (unchanged): Dilekçe only for admins and the people
 * petitions are addressed to; the expense approval list only for admins;
 * Kargolarım for admins and employees given cargo access.
 */
export const isTabVisible = (tab, { isAdmin, isComplaintTarget, canUseCargo }) => {
  if (tab === 'sikayetlerim' || tab === 'gelen-sikayetler') return isAdmin || isComplaintTarget;
  if (tab === 'masraf-talepleri') return isAdmin;
  if (tab === 'kargolarim') return canUseCargo;
  return true;
};
